export default class Main {

	constructor() {
		this.init();
	}

	init() {
				/* inizio gestione transizioni siti */
				$('.sidebars [data-link]').on('click',function(){
					$('.info-modal--btn').css({
						transform: 'translateY(100px)'
					})
					var target = $(this).attr('data-target'),
									origin = $(this).attr('data-origin'),
									link = $(this).attr('data-link')
					$('html,body').addClass('transitioning')
					$('.sidebar--'+target).addClass('sidebar--expanded')
					$('.sidebar--expanded .logo').fadeOut(500)
					setTimeout(function(){
									// $('.sidebar--expanded .logo').addClass('logo--expanded')
									// $('.logo--expanded').fadeIn(500)
                                    $('.logo--transition').fadeIn(500)
					},1500)
					setTimeout(function(){
						//$('body').addClass('wait')
						window.location.href = link
					},4000)
        })        

        const urlParams = new URLSearchParams(window.location.search);
        const transition = urlParams.get('transition');
        if(transition) {
                $('.current')
                        .addClass('sidebar--expanded')
                $('html,body')
                        .addClass('transitioning')
                        .addClass('transitioning-in')
                $('.current .logo')
                        .addClass('logo--expanded')
                
                setTimeout(function(){
                    $('.logo--expanded').fadeOut(1500)
                },1500)

								setTimeout(function(){
									$('html,body')
										.removeClass('wait')
									$('.current').css({
										transition: 'all 1.5s ease-in-out',
										opacity:0
									})
									$('.section--hero--homepage .brands--slides').slick('reinit')
									heroHomeSlider()
								},3000)

                setTimeout(function(){
									$('.current').remove()
									$('.sidebars > *').css({
										transition: 'opacity 1.5s ease-in-out',
										opacity:1
									})
									$('html,body')
											.removeClass('transitioning')
											.removeClass('transitioning-in')
                },4500)
        }
        else {
                $('body').removeClass('wait')
								heroHomeSlider()
        }        
        /* fine gestione transizioni siti */

			$('.transition-mobile--toggle').on('click', function() {
					$('body,html').toggleClass('transition-mobile--modal--open')
			})

		/*
		function debounce(method) {
			clearTimeout(method._tId);
			method._tId= setTimeout(function(){
				method();
			}, 150);
		}
		*/

		// lang selector
		if (typeof (CountrySearch) !== 'undefined' && $('#panel-markets .form-control').length > 0) {
			CountrySearch.Setup('#panel-markets .form-control', '#panel-markets .group--results', '.trigger--markets');
		}

		// search
		if (typeof (SiteSearch) !== 'undefined' && $('#panel-search .form-control').length > 0) {
			SiteSearch.Setup('#panel-search .form-control', '#panel-search .group--results', '.trigger--search');
		}

		// market proprosition popup
		$('[data-market-proposition] .close, [data-market-proposition] .btn-close').on('click', function(event) {
			document.cookie = "marketPropositionPopup=hide; expires=0; path=/";
			$('[data-market-proposition]').remove();

			return false;
		});

		$('[data-logout]').on('click', function(event) {
			event.preventDefault();

			$.ajax({
				type: "POST",
				url: "/ws/wsAreaUtente.asmx/Logout",
				cache: false,
				contentType: "application/json; charset=utf-8",
				dataType: "json"
			}).done(function (data)
			{
				location.reload();
			}).fail(function (jqXHR, textStatus, errorThrown)
			{
				alert(textStatus + " " + errorThrown);
			});

			return false;
		});

		$('#panel-search .form-control').keypress(function(event) {
			if (event.which == 13) {
				event.preventDefault();
			}
		});

		$(window).scroll(function() {
			let scroll = $(window).scrollTop();
			if (scroll > 10) {
				$('body').addClass('scrolling')
			}
			else {
				$('body').removeClass('scrolling')
			}
		})

		let aosSettings = {
			once: true, // whether animation should happen only once - while scrolling down
			mirror: false, // whether elements should animate out while scrolling past them
		}

		AOS.init(aosSettings)

        //setTimeout(function(){
            var $progetti = $('.listing-progetti .items').isotope({
                itemSelector: '.list-item',
                layoutMode: 'fitRows',
            });
        //},2000)

        $('.header .user').on('click',function(e){
            e.stopPropagation()
            $('.header .submenu-user').toggle()
        })

        $(window).on('click', function(){
            $('.header .submenu-user').hide()
        })

		$('.progetti .filters input[type="radio"]').on('click', function(e) {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active')
				$(this).prop('checked', false)
				$progetti.isotope({ filter: '*' })
				return
			}
			$('.active').removeClass('active')
			$(this).addClass('active')
			let activeFilter = $('.progetti .filters input[type="radio"]:checked').val()
			$progetti.isotope({ filter: '[data-progetto-stato=' + activeFilter + ']' })
            AOS.init(aosSettings)
		})

		$('.menu-1--open').on('click', function() {
			$(this).parent().find('.menu-2').show(0).addClass('visible');
			$('body').addClass('menu-2-visible');
		})

		$('.menu--close-2').on('click', function(event) {
			console.log('.menu--close-2', event);
			$('.menu-2').removeClass('visible').hide(0);
			$('body').removeClass('menu-2-visible');
		})

		$('.menu-2--open').on('click', function() {
			$(this).parent().find('.menu-3').show(0).addClass('visible');
			$('body').addClass('menu-3-visible');
		})

		$('.menu--close-3').on('click', function(event) {
			console.log('.menu--close-3', event);
			$('.menu-3').removeClass('visible').hide(0);
			$('body').removeClass('menu-3-visible');
		})

		// section slider
		$('.section-slider .slides')
			.on('init', function(event, slick, direction) {
				let slider = $(slick.$slider[0]),
					arrows = slider.parent().find('.nav')

				arrows.find('.prev').addClass('disabled')
			})
			.on('afterChange', function(event, slick, currentSlide, nextSlide) {
				let slider = $(slick.$slider[0]),
					slides = $(slick.$slides),
					arrows = slider.parent().find('.nav')

				arrows.find('.disabled').removeClass('disabled')

				if (currentSlide == 0) {
					arrows.find('.prev').addClass('disabled')
				}

				if (currentSlide == slides.length - 1) {
					arrows.find('.next').addClass('disabled')
				}

				setTimeout(function() {
					slider.removeClass('slider--transition-in')
				}, 300)
			})
			.slick({
				arrows: false,
				infinite: false,
				dots: false,
				variableWidth: true,
				//draggable: false,
				useTransform: false,
				//useCSS: false,
			})

		$('[data-nav-selector] .prev').on('click', function(e) {
			if ($(this).hasClass('disabled')) return
			let selector = $(this).closest('[data-nav-selector]').attr('data-nav-selector')
			$(selector).addClass('slider--transition-in')
			setTimeout(function() {
				$(selector).slick('slickPrev')
			}, 300)
		})

		$('[data-nav-selector] .next').on('click', function(e) {
			if ($(this).hasClass('disabled')) return
			let selector = $(this).closest('[data-nav-selector]').attr('data-nav-selector')
			$(selector).addClass('slider--transition-in')
			setTimeout(function() {
				$(selector).slick('slickNext')
			}, 300)
		})


		// modals
		$('[data-modal-open]').on('click', function(e) {
            if ($(this).hasClass('disabled')) {
                return;
            }
            
			let modal = $($(this).attr('data-modal-open'))
			modal.show(0, function() {
				$('body,html').addClass('modal-open')
			})
			setTimeout(function() {
				$('.slick-initialized').parent().find('.prev').trigger('click')
			}, 100)
		})

		$('[data-modal-close], [data-modal-close] *').on('click', function(e) {
			e.preventDefault()
			$('body,html').removeClass('modal-open')
			let modal = $(this).closest('.modal')
			setTimeout(function() {
				modal.hide(0)
			}, 1500)
		})

		// ref slider
		$('.ref--list')
			.on('init', function(event, slick, direction) {
				let slider = $(slick.$slider[0]),
					arrows = slider.parent().find('.nav')

				arrows.find('.prev')
					.addClass('disabled')
					.on('click', function() {
						$(slick.$slider[0]).slick('slickPrev');
					})

				arrows.find('.next')
					.on('click', function() {
						$(slick.$slider[0]).slick('slickNext');
					})

				arrows.find('.current').html(1)

				arrows.find('.last').html($(slick.$slides).length)
			})
			.on('afterChange', function(event, slick, currentSlide, nextSlide) {
				let slider = $(slick.$slider[0]),
					slides = $(slick.$slides),
					arrows = slider.parent().find('.nav')

				arrows.find('.disabled').removeClass('disabled')
				arrows.find('.current').html(currentSlide + 1)
				if (currentSlide == 0) {
					arrows.find('.prev').addClass('disabled')
				}
				if (currentSlide == slides.length - 1) {
					arrows.find('.next').addClass('disabled')
				}
				setTimeout(function() {
					slider.removeClass('slider--transition-in')
				}, 300)
			})
			.slick({
				arrows: false,
				infinite: false,
				dots: false,
				variableWidth: true,
				//draggable: false,
				useTransform: false,
				//useCSS: false,
			})


		// prod slider
		$('.prod-slider')
			.on('init', function(event, slick, direction) {
				let slider = $(slick.$slider[0]),
					arrows = slider.parent().find('.nav')

				arrows.find('.prev')
					.addClass('disabled')
					.on('click', function() {
						$(slick.$slider[0]).slick('slickPrev');
					})

				arrows.find('.next')
					.on('click', function() {
						$(slick.$slider[0]).slick('slickNext');
					})

				arrows.find('.current').html(1)

				arrows.find('.last').html($(slick.$slides).length)
			})
			.on('afterChange', function(event, slick, currentSlide, nextSlide) {
				let slider = $(slick.$slider[0]),
					slides = $(slick.$slides),
					arrows = slider.parent().find('.nav')

				arrows.find('.disabled').removeClass('disabled')
				arrows.find('.current').html(currentSlide + 1)
				if (currentSlide == 0) {
					arrows.find('.prev').addClass('disabled')
				}
				if (currentSlide == slides.length - 1) {
					arrows.find('.next').addClass('disabled')
				}
				setTimeout(function() {
					slider.removeClass('slider--transition-in')
				}, 300)
			})
			.slick({
				arrows: false,
				infinite: false,
				dots: false,
				variableWidth: true,
				//draggable: false,
				useTransform: false,
				//useCSS: false,
			})



		// hero slider
		function heroHomeSlider() {
			$('.section--hero--slider .slides')
				.on('init', function(event, slick, direction) {
					let slider = $(slick.$slider[0]),
						arrows = slider.parent().find('.hero-arrows'),
											nav = slider.parent().find('.nav')

					arrows.find('.prev')
						.addClass('disabled')
						.on('click', function() {
							$(slick.$slider[0]).slick('slickPrev');
						})

					arrows.find('.next')
						.on('click', function() {
							$(slick.$slider[0]).slick('slickNext');
						})

									nav.find('.current').html(1)

									nav.find('.last').html($(slick.$slides).length)
				})
				.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					let slider = $(slick.$slider[0])

					slider.find('.in-view').each(function(e){
											$(this)
													.css({
															visibility: 'hidden'
													})
													.removeClass('in-view')
													.addClass('to-view')
									})
					slider.find('.btn').each(function(e){
											$(this)
													.css({
															transition: 'none',
															opacity: 0
													})
									})
									
				})
				.on('afterChange', function(event, slick, currentSlide, nextSlide) {
					let slider = $(slick.$slider[0]),
						slides = $(slick.$slides),
						arrows = slider.parent().find('.hero-arrows'),
											nav = slider.parent().find('.nav')

									nav.find('.disabled').removeClass('disabled')
					nav.find('.current').html(currentSlide + 1)

									if (currentSlide == 0) {
						arrows.find('.prev').addClass('disabled')
					}
					if (currentSlide == slides.length - 1) {
						arrows.find('.next').addClass('disabled')
					}
					setTimeout(function() {
						slider.removeClass('slider--transition-in')
											slider.find('.to-view').each(function(e){
													$(this)
															.removeAttr('style')
															.removeClass('to-view')
															.addClass('in-view')
											})  
					}, 200)
					setTimeout(function() {
											slider.find('.btn').each(function(e){
													$(this).css({
															transition: 'all 0.3s linear',
															opacity: 1
													})
											})    
					}, 1200)
				})
				.slick({
					arrows: false,
					infinite: false,
					dots: false,
									fade:true,
									speed:2000,
					//draggable: false,
					//useCSS: false,
				})            
		}

		$('.dropdown--link').on('click', function(e) {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active')
				$(this).parent().find('.dropdown--list').toggle(500)
				return
			}
			$('.dropdown--link.active').parent().find('.dropdown--list').toggle(500)
			$('.dropdown--link.active').removeClass('active')
			$(this).addClass('active')
			$(this).parent().find('.dropdown--list').toggle(500)
		})


		// menu
		$('.menu-toggle.mobile').on('click', function() {
			if ($('body,html').hasClass('menu-open')) {
				$('.menu-2, .menu-3').removeClass('visible')
				$('body')
					.removeClass('menu-2-visible')
					.removeClass('menu-3-visible')

				$('body,html').toggleClass('menu-open')
				setTimeout(function() {
					$('.menu').toggle(0)
					$('.menu-2, .menu-3').hide(0)
				}, 250)
			}
			else {
				$('.menu').toggle(0)
				$('body,html').toggleClass('menu-open')
			}
		})

		/*
		$('.menu--back .menu-toggle')
		{
			$('body')
			.removeClass('menu-2-visible')
			.removeClass('menu-3-visible')
			.removeClass('menu-open')

			$('.menu').toggle(0)
		}
		*/

		// menu desktop
		$('.menu-toggle.desktop, #toggle-menu-desktop').on('click', function() {
			$('body,html').removeClass('search-lg-open')
			if ($('body,html').hasClass('menu-open-desktop')) {
				$('body,html').toggleClass('menu-open-desktop')
				setTimeout(function() {
					$('.menu-desktop').hide(0)
					//$('.menu-2, .menu-3').hide(0)
				}, 250)
			}
			else {
				$('.menu-desktop').show(0)
				$('body,html').toggleClass('menu-open-desktop')
			}
		})

		// menu annidati desktop
		$('.menu-desktop .first li').on('mouseenter', function() {
			if ($('body').hasClass('transitioning')) return
			$('body').addClass('transitioning')
			$('.menu-desktop .first li.selected').removeClass('selected')
			$(this).addClass('selected')
			$('.menu-desktop .second.visible').removeClass('visible')
			let next = $(this).attr('data-show')
			//setTimeout(function(){
			$('.menu-desktop .second.' + next).addClass('visible')
			$('body').removeClass('transitioning')
			//},150)
		})
		$('.menu-desktop .second li').on('mouseenter', function() {
			if ($('body').hasClass('transitioning')) return
			$('body').addClass('transitioning')
			$('.menu-desktop .second li.selected').removeClass('selected')
			$(this).addClass('selected')
			$('.menu-desktop .thumb.visible').removeClass('visible')
			let next = $(this).find('.thumb')
			//setTimeout(function(){
			next.addClass('visible')
			$('body').removeClass('transitioning')
			//},150)
		})

		$('.search-lg, .search-lg-content .close, .trigger--search.btn--close').on('click', function(e) {
            e.preventDefault()
			$('body,html').removeClass('menu-open')
			$('body,html').removeClass('menu-open-desktop')
			$('body,html').removeClass('search-lg-open')
			$('body,html').removeClass('menu-2-visible')
			$('.menu').toggle()
			return
		})

		// JS componente Video
		$('.fascia-video .play-video.mp4').on('click', function () {
			$('.fascia-video .play-video').addClass('disabled');
			$('.fascia-video video').trigger('play');
			return false;
		});
		$('.fascia-video .play-video.youtube').on('click', function () {
			$('.fascia-video .play-video').addClass('disabled');
			$("#youtubevideo")[0].src += "?autoplay=1";
			return false;
		});

		// scroll button
		$('[data-scroll]').on('click', function(e) {
			let selector = $(this).attr('data-scroll'),
				headerHeight = $('.header').outerHeight()
			$('html,body')
				.stop()
				.animate({
					scrollTop: $(selector).offset().top// - 2*headerHeight
				}, 1000)
		})

		$('.load-more').on('click', function() {
			$('.listing--wrapper').addClass('loading')
			window.loadMoreCallback(getActiveFilters())
		})

		$('.filters-toggle').on('click', function(e) {
			$(this).parent().find('.filters-list').toggle(500)
		})

		function getActiveFilters() {
			let targets = []

			$('.active-filters .filter').each(function(f) {
				targets.push($(this)[0].getAttribute('data-filter'))
			})

			return targets
		}

		function toggleFilter(e) {
			$('.listing--wrapper').addClass('loading')

			let dataFilter = $(e).attr('data-filter'),
				labelFilter = $(e).html()

			if ($(e).hasClass('active')) {
				$(e).removeClass('active')
				$('.active-filters [data-filter=' + dataFilter + ']').remove()
				$('.all-filters [data-filter=' + dataFilter + ']').removeClass('active')
			}
			else {
				$(e).addClass('active')
				let filter = $('<span data-filter="' + dataFilter + '" class="filter active">' + labelFilter + ' <svg class="erase" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="23.99 2.22 21.78 0.01 12 9.79 2.22 0.01 0.01 2.22 9.79 12 0.01 21.78 2.22 23.99 12 14.21 21.78 23.99 23.99 21.78 14.21 12 23.99 2.22"/></svg></span>')
				filter.on('click', function(e) {
					toggleFilter(this)
				})
				$('.active-filters').append(filter)
			}

			window.changedFilterCallback(getActiveFilters())
		}


		$('.mood--slider .slides, .ref--slider .slides')
			.on('init', function(event, slick, direction) {
				let slider = $(slick.$slider[0]),
					arrows = slider.parent().find('.nav')

				arrows.find('.prev').addClass('disabled')
				arrows.find('.last').html(slick.$slides.length)
			})
			.on('afterChange', function(event, slick, currentSlide, nextSlide) {
				let slider = $(slick.$slider[0]),
					slides = $(slick.$slides),
					arrows = slider.parent().find('.nav')

				arrows.find('.disabled').removeClass('disabled')

				if (currentSlide == 0) {
					arrows.find('.prev').addClass('disabled')
				}

				if (currentSlide == slides.length - 1) {
					arrows.find('.next').addClass('disabled')
				}

				arrows.find('.current').html(currentSlide + 1)

				setTimeout(function() {
					slider.removeClass('slider--transition-in')
				}, 300)
			})
			.slick({
				arrows: false,
				//fade:true,
				infinite: true,
				dots: false,
				variableWidth: true,
				centerMode: true,
				//draggable: false,
				//useTransform: false,
				//useCSS: false,
			})


		/*
		$('[data-filter]').on('click',function(e){
			toggleFilter(this)
		})
		*/


		// menu filtri mobile
		$('.filters-open-menu').on('click', function() {
			if ($('body,html').hasClass('menu-filters-open')) {
				$('body,html').toggleClass('menu-filters-open')
				setTimeout(function() {
					$('.menu').toggle(0)
					$('.all-filters').hide(0)
				}, 250)
			}
			else {
				$('.all-filters').toggle(0)
				$('body,html').toggleClass('menu-filters-open')
			}
		})

		// menu filtri mobile
		$('.close-mobile-filters, .apply-mobile-filters').on('click', function() {
			$('.all-filters').toggle(0)
			$('body,html').removeClass('menu-filters-open')
		})

		// effetti comparsa titoli
		const splitLines = document.querySelectorAll("[data-split-lines]")

		function splits() {
			splitLines.forEach((item) => {
				item.split = new SplitText(item, {
					type: "lines,words",
					linesClass: "split-line"
				})
				gsap.from(item, {
					scrollTrigger: {
						start: 'top bottom',
						end: 'bottom top',
						trigger: item,
						//toggleClass: 'in-view'
						onEnter: () => { item.classList.add('in-view') }
					}
				})
			})
		}

		setTimeout(function() {
			splits()
			$('body').addClass('splitted-texts')
		}, 1000)


        if(window.innerWidth >= 1280)
        {
            let h = $('.total .downloads').outerHeight()
            $('body.progetto main.page').css({
                minHeight: $('.total').outerHeight() + 600
            })
            $(window).scroll(function() {
                $('body.progetto .products').css({
                    marginTop: -h
                })
            })
        }
	}

}

const main = new Main();
